<template>
    <div>
        <div v-if="errors.length">
            <d-alert class="mb-0" v-for="error in errors" :key="error" theme="danger" show dismissible>{{ error
                }}</d-alert>
        </div>
        <div class="main-content-container container-fluid px-4">
            <!-- Page Header -->
            <div class="page-header row no-gutters pt-4 pb-2">
                <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                    <span class="text-uppercase page-subtitle">MINIBUS</span>
                </div>
            </div>
            <div class="row flex pb-2">
                <h5 class="float-left font-weight-bold mb-0 ml-5">
                    {{ $t("minibus.managment.demand.title") }} : {{ beneficiary.firstName }} {{ beneficiary.lastName }}
                    {{ beneficiary.isExternalPerson ? "( Personne Externe )" : ` - ${beneficiary.structName}` }} {{
                        manuelReservation ? " (Réservation Manuelle)" : "" }}
                </h5>
                <div class="col-12 mt-5">
                    <button class="btn btn-outline wizard-btn return-btn float-left" @click="backToList()">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        {{ $t("global.return") }}
                    </button>
                    <button v-if="edit" class="btn btn-danger next-btn float-right mx-2 px-7" @click="cancelEditing()">
                        <!-- {{ $t("minibus.managment.demand.button.edit") }} -->
                        Annuler
                    </button>
                    <button class="btn btn-warning next-btn float-right mx-2 px-7" @click="editDemand()">
                        {{ edit ? "Confirmer" : $t("minibus.managment.demand.button.edit") }}
                    </button>
                    <button
                        v-if="((this.$store.state.user.informations.permissions[0].groupReference == '_receptionist' && request.answers[1].status == 'PENDING' && request.answers[1].status == 'PENDING') || (this.$store.state.user.informations.permissions[0].groupReference == '_super_admin' && request.answers[0].status == 'PENDING'))"
                        class="btn wizard-btn next-btn float-right mx-2 px-7" @click="validate()">
                        {{ $t("minibus.managment.demand.button.accept") }}
                    </button>
                    <button class="btn btn-danger next-btn float-right mx-2 px-7" @click="deleteDemand()">
                        {{ $t("minibus.managment.demand.button.delete") }}
                    </button>
                    <button class="float-right planing-btn" @click="goToPlaning()">
                        {{ $t("minibus.managment.demand.button.planning") }}
                    </button>
                </div>
            </div>
            <div class="mb-4 pb-5">
                <spinner-dot v-if="loading" />
                <template v-else>
                    <div class="card card-small mb-4 mt-3">
                        <div class="card-body">
                            <div class="py-2 px-3">
                                <h5 class="mb-4">{{ $t("days.off.request.step.five.title") }}</h5>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div v-if="request.isExternalClient" class="row">
                                            <div v-if="request.firstName != null" class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29"
                                                                height="40.04" viewBox="0 0 32.29 40.04">
                                                                <defs>
                                                                    <clipPath id="clip-path">
                                                                        <path id="Path_111" data-name="Path 111"
                                                                            d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z"
                                                                            transform="translate(-2528 -583.5)"
                                                                            fill="#303778" />
                                                                    </clipPath>
                                                                    <clipPath id="clip-path-2">
                                                                        <rect id="Rectangle_204"
                                                                            data-name="Rectangle 204" width="731.907"
                                                                            height="480.475" fill="#303778" />
                                                                    </clipPath>
                                                                </defs>
                                                                <g id="Group_745" data-name="Group 745"
                                                                    clip-path="url(#clip-path)">
                                                                    <g id="Group_744" data-name="Group 744"
                                                                        transform="translate(-566.869 -132.859)">
                                                                        <g id="Group_743" data-name="Group 743"
                                                                            transform="translate(0 0)"
                                                                            clip-path="url(#clip-path-2)">
                                                                            <rect id="Rectangle_203"
                                                                                data-name="Rectangle 203" width="41.259"
                                                                                height="49.14"
                                                                                transform="translate(562.384 128.309)"
                                                                                fill="#303778" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.first.name") }}</p>
                                                            <d-input v-if="edit" type="text"
                                                                v-model="request.firstName" />
                                                            <span v-else>{{ request.firstName }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="request.lastName != null" class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29"
                                                                height="40.04" viewBox="0 0 32.29 40.04">
                                                                <defs>
                                                                    <clipPath id="clip-path">
                                                                        <path id="Path_111" data-name="Path 111"
                                                                            d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z"
                                                                            transform="translate(-2528 -583.5)"
                                                                            fill="#303778" />
                                                                    </clipPath>
                                                                    <clipPath id="clip-path-2">
                                                                        <rect id="Rectangle_204"
                                                                            data-name="Rectangle 204" width="731.907"
                                                                            height="480.475" fill="#303778" />
                                                                    </clipPath>
                                                                </defs>
                                                                <g id="Group_745" data-name="Group 745"
                                                                    clip-path="url(#clip-path)">
                                                                    <g id="Group_744" data-name="Group 744"
                                                                        transform="translate(-566.869 -132.859)">
                                                                        <g id="Group_743" data-name="Group 743"
                                                                            transform="translate(0 0)"
                                                                            clip-path="url(#clip-path-2)">
                                                                            <rect id="Rectangle_203"
                                                                                data-name="Rectangle 203" width="41.259"
                                                                                height="49.14"
                                                                                transform="translate(562.384 128.309)"
                                                                                fill="#303778" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.last.name") }}</p>
                                                            <d-input v-if="edit" type="text"
                                                                v-model="request.lastName" />
                                                            <span v-else>{{ request.lastName }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div v-if="request.isExternalClient" class="row">
                                            <div v-if="request.email != null" class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29"
                                                                height="40.04" viewBox="0 0 32.29 40.04">
                                                                <defs>
                                                                    <clipPath id="clip-path">
                                                                        <path id="Path_111" data-name="Path 111"
                                                                            d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z"
                                                                            transform="translate(-2528 -583.5)"
                                                                            fill="#303778" />
                                                                    </clipPath>
                                                                    <clipPath id="clip-path-2">
                                                                        <rect id="Rectangle_204"
                                                                            data-name="Rectangle 204" width="731.907"
                                                                            height="480.475" fill="#303778" />
                                                                    </clipPath>
                                                                </defs>
                                                                <g id="Group_745" data-name="Group 745"
                                                                    clip-path="url(#clip-path)">
                                                                    <g id="Group_744" data-name="Group 744"
                                                                        transform="translate(-566.869 -132.859)">
                                                                        <g id="Group_743" data-name="Group 743"
                                                                            transform="translate(0 0)"
                                                                            clip-path="url(#clip-path-2)">
                                                                            <rect id="Rectangle_203"
                                                                                data-name="Rectangle 203" width="41.259"
                                                                                height="49.14"
                                                                                transform="translate(562.384 128.309)"
                                                                                fill="#303778" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.email") }}</p>
                                                            <d-input v-if="edit" type="text" v-model="request.email" />
                                                            <span v-else>{{ request.email }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="request.destination != null" class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29"
                                                                height="40.04" viewBox="0 0 32.29 40.04">
                                                                <defs>
                                                                    <clipPath id="clip-path">
                                                                        <path id="Path_111" data-name="Path 111"
                                                                            d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z"
                                                                            transform="translate(-2528 -583.5)"
                                                                            fill="#303778" />
                                                                    </clipPath>
                                                                    <clipPath id="clip-path-2">
                                                                        <rect id="Rectangle_204"
                                                                            data-name="Rectangle 204" width="731.907"
                                                                            height="480.475" fill="#303778" />
                                                                    </clipPath>
                                                                </defs>
                                                                <g id="Group_745" data-name="Group 745"
                                                                    clip-path="url(#clip-path)">
                                                                    <g id="Group_744" data-name="Group 744"
                                                                        transform="translate(-566.869 -132.859)">
                                                                        <g id="Group_743" data-name="Group 743"
                                                                            transform="translate(0 0)"
                                                                            clip-path="url(#clip-path-2)">
                                                                            <rect id="Rectangle_203"
                                                                                data-name="Rectangle 203" width="41.259"
                                                                                height="49.14"
                                                                                transform="translate(562.384 128.309)"
                                                                                fill="#303778" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.destination") }}</p>
                                                            <d-input v-if="edit" type="text"
                                                                v-model="request.destination" />
                                                            <span v-else>{{ request.destination }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg width="44px" height="44px" viewBox="0 0 44 44"
                                                                version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                                <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                                                                <title>Iconspace_Calendar</title>
                                                                <desc>Created with Sketch.</desc>
                                                                <g id="Page-1" stroke="none" stroke-width="1"
                                                                    fill="none" fill-rule="evenodd">
                                                                    <g id="Antarmuka_One-Color-UI-element-1"
                                                                        transform="translate(-338.000000, -242.000000)">
                                                                        <g id="Iconspace_Calendar"
                                                                            transform="translate(336.000000, 240.000000)">
                                                                            <polygon id="Shape"
                                                                                points="0 0 48 0 48 48 0 48" />
                                                                            <path
                                                                                d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                                                                id="Shape" fill="#303778"
                                                                                fill-rule="nonzero" />
                                                                            <polygon id="Shape" fill="#303778"
                                                                                points="10 18 18 18 18 26 10 26" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.from") }}</p>
                                                            <d-datepicker v-if="edit" id="datepicker" class="pr-1"
                                                                v-model="request.fromDate" placeholder="Date de debut"
                                                                @input="checkDates"
                                                                :input-class="['form-control', 'datepicker', 'py-3']"
                                                                :language="fr" small></d-datepicker>
                                                            <span v-else>{{ formatDate(new Date(request.fromDate))
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg width="44px" height="44px" viewBox="0 0 44 44"
                                                                version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                                <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                                                                <title>Iconspace_Calendar</title>
                                                                <desc>Created with Sketch.</desc>
                                                                <g id="Page-1" stroke="none" stroke-width="1"
                                                                    fill="none" fill-rule="evenodd">
                                                                    <g id="Antarmuka_One-Color-UI-element-1"
                                                                        transform="translate(-338.000000, -242.000000)">
                                                                        <g id="Iconspace_Calendar"
                                                                            transform="translate(336.000000, 240.000000)">
                                                                            <polygon id="Shape"
                                                                                points="0 0 48 0 48 48 0 48" />
                                                                            <path
                                                                                d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                                                                id="Shape" fill="#303778"
                                                                                fill-rule="nonzero" />
                                                                            <polygon id="Shape" fill="#303778"
                                                                                points="10 18 18 18 18 26 10 26" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.to") }}</p>
                                                            <d-datepicker v-if="edit" id="datepicker" class="pr-1"
                                                                v-model="request.toDate" placeholder="Date de fin"
                                                                @input="checkDates"
                                                                :input-class="['form-control', 'datepicker', 'py-3']"
                                                                :language="fr" small></d-datepicker>
                                                            <span v-else>{{ formatDate(new Date(request.toDate))
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg width="44px" height="44px" viewBox="0 0 44 44"
                                                                version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                                <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                                                                <title>Iconspace_Calendar</title>
                                                                <desc>Created with Sketch.</desc>
                                                                <g id="Page-1" stroke="none" stroke-width="1"
                                                                    fill="none" fill-rule="evenodd">
                                                                    <g id="Antarmuka_One-Color-UI-element-1"
                                                                        transform="translate(-338.000000, -242.000000)">
                                                                        <g id="Iconspace_Calendar"
                                                                            transform="translate(336.000000, 240.000000)">
                                                                            <polygon id="Shape"
                                                                                points="0 0 48 0 48 48 0 48" />
                                                                            <path
                                                                                d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                                                                id="Shape" fill="#303778"
                                                                                fill-rule="nonzero" />
                                                                            <polygon id="Shape" fill="#303778"
                                                                                points="10 18 18 18 18 26 10 26" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.starting.hour") }}</p>
                                                            <div v-if="edit" class="row pl-3 pt-2 mb-1">
                                                                <div
                                                                    class="d-flex align-items-center justify-content-center">
                                                                    <select id="hourStart" class="form-control mt-0"
                                                                        v-model="model.startHour" @input="checkDates"
                                                                        @change="$emit('updateDate', model)"
                                                                        :disabled="disabled">
                                                                        <option v-for="(h, idx) in hours" :key="idx"
                                                                            :value="h">
                                                                            {{ h }}
                                                                        </option>
                                                                    </select>
                                                                    <label class="text-label mx-2 mb-0">H:</label>
                                                                </div>

                                                                <div
                                                                    class="d-flex align-items-center justify-content-center">
                                                                    <select id="minuteStart" class="form-control mt-0"
                                                                        v-model="model.startMinute" @input="checkDates"
                                                                        @change="$emit('updateDate', model)"
                                                                        :disabled="disabled">
                                                                        <option v-for="(m, idx) in minutes" :key="idx"
                                                                            :value="m">
                                                                            {{ m }}
                                                                        </option>
                                                                    </select>
                                                                    <label class="text-label ml-2 mb-0">Min</label>
                                                                </div>
                                                            </div>
                                                            <span v-else>{{ `${model.startHour}:${model.startMinute}`
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg width="44px" height="44px" viewBox="0 0 44 44"
                                                                version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                                <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
                                                                <title>Iconspace_Calendar</title>
                                                                <desc>Created with Sketch.</desc>
                                                                <g id="Page-1" stroke="none" stroke-width="1"
                                                                    fill="none" fill-rule="evenodd">
                                                                    <g id="Antarmuka_One-Color-UI-element-1"
                                                                        transform="translate(-338.000000, -242.000000)">
                                                                        <g id="Iconspace_Calendar"
                                                                            transform="translate(336.000000, 240.000000)">
                                                                            <polygon id="Shape"
                                                                                points="0 0 48 0 48 48 0 48" />
                                                                            <path
                                                                                d="M40,6 L46,6 L46,46 L2,46 L2,6 L8,6 L8,2 L12,2 L12,6 L36,6 L36,2 L40,2 L40,6 Z M42,14 L6,14 L6,42 L42,42 L42,14 Z"
                                                                                id="Shape" fill="#303778"
                                                                                fill-rule="nonzero" />
                                                                            <polygon id="Shape" fill="#303778"
                                                                                points="10 18 18 18 18 26 10 26" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.ending.hour") }}</p>
                                                            <div v-if="edit" class="row pl-3 pt-2 mb-1">
                                                                <div
                                                                    class="d-flex align-items-center justify-content-center">
                                                                    <select id="hourStart" class="form-control mt-0"
                                                                        v-model="model.endHour" @input="checkDates"
                                                                        @change="$emit('updateDate', model)"
                                                                        :disabled="disabled">
                                                                        <option v-for="(h, idx) in hours" :key="idx"
                                                                            :value="h">
                                                                            {{ h }}
                                                                        </option>
                                                                    </select>
                                                                    <label class="text-label mx-2 mb-0">H:</label>
                                                                </div>

                                                                <div
                                                                    class="d-flex align-items-center justify-content-center">
                                                                    <select id="minuteStart" class="form-control mt-0"
                                                                        v-model="model.endMinute" @input="checkDates"
                                                                        @change="$emit('updateDate', model)"
                                                                        :disabled="disabled">
                                                                        <option v-for="(m, idx) in minutes" :key="idx"
                                                                            :value="m">
                                                                            {{ m }}
                                                                        </option>
                                                                    </select>
                                                                    <label class="text-label ml-2 mb-0">Min</label>
                                                                </div>
                                                            </div>
                                                            <span v-else>{{ `${model.endHour}:${model.endMinute}`
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </div>
                                        <div v-if="!request.isExternalClient" class="row">
                                            <div v-if="request.destination != null" class="col-md-12 col-lg-6">
                                                <div class="step4-card">
                                                    <div class="d-flex">
                                                        <div class="svg-wrapper">
                                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                                xmlns:xlink="http://www.w3.org/1999/xlink" width="32.29"
                                                                height="40.04" viewBox="0 0 32.29 40.04">
                                                                <defs>
                                                                    <clipPath id="clip-path">
                                                                        <path id="Path_111" data-name="Path 111"
                                                                            d="M2531.588,607.16v16.38H2528V583.5h32.29v23.66Zm-.005-3.64h25.125V587.14h-25.125Z"
                                                                            transform="translate(-2528 -583.5)"
                                                                            fill="#303778" />
                                                                    </clipPath>
                                                                    <clipPath id="clip-path-2">
                                                                        <rect id="Rectangle_204"
                                                                            data-name="Rectangle 204" width="731.907"
                                                                            height="480.475" fill="#303778" />
                                                                    </clipPath>
                                                                </defs>
                                                                <g id="Group_745" data-name="Group 745"
                                                                    clip-path="url(#clip-path)">
                                                                    <g id="Group_744" data-name="Group 744"
                                                                        transform="translate(-566.869 -132.859)">
                                                                        <g id="Group_743" data-name="Group 743"
                                                                            transform="translate(0 0)"
                                                                            clip-path="url(#clip-path-2)">
                                                                            <rect id="Rectangle_203"
                                                                                data-name="Rectangle 203" width="41.259"
                                                                                height="49.14"
                                                                                transform="translate(562.384 128.309)"
                                                                                fill="#303778" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </div>
                                                        <div class="">
                                                            <p>{{ $t("minibus.request.step.three.destination") }}</p>
                                                            <d-input v-if="edit" type="text"
                                                                v-model="request.destination" />
                                                            <span v-else>{{ request.destination }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="col-lg-6">
                                        <div v-for="(answer, idx) in request.answers.slice(0, 1)" :key="idx"
                                            class="d-inline float-right">
                                            <div v-if="answer.groupReference == '_super_admin' && answer.status == 'ACCEPTED'"
                                                class="minibus-demand-positive-opnion d-flex align-items-center justify-content-center">
                                                <svg height="50" width="50" color="#FFFFFF"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 576 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                                    <path fill="#FFFFFF"
                                                        d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V198.6C310.1 219.5 256 287.4 256 368C256 427.1 285.1 479.3 329.7 511.3C326.6 511.7 323.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256zM576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368zM476.7 324.7L416 385.4L387.3 356.7C381.1 350.4 370.9 350.4 364.7 356.7C358.4 362.9 358.4 373.1 364.7 379.3L404.7 419.3C410.9 425.6 421.1 425.6 427.3 419.3L499.3 347.3C505.6 341.1 505.6 330.9 499.3 324.7C493.1 318.4 482.9 318.4 476.7 324.7H476.7z" />
                                                </svg>
                                                <span>APPROUVÉ PAR LE DIRECTEUR</span>
                                            </div>
                                            <div v-else-if="answer.groupReference == '_super_admin' && answer.status == 'REFUSED'"
                                                class="minibus-demand-negative-opnion d-flex align-items-center justify-content-center">
                                                <svg height="50" width="50" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 576 512"><!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                                    <path fill="#FFFFFF"
                                                        d="M0 64C0 28.65 28.65 0 64 0H224V128C224 145.7 238.3 160 256 160H384V198.6C310.1 219.5 256 287.4 256 368C256 427.1 285.1 479.3 329.7 511.3C326.6 511.7 323.3 512 320 512H64C28.65 512 0 483.3 0 448V64zM256 128V0L384 128H256zM288 368C288 288.5 352.5 224 432 224C511.5 224 576 288.5 576 368C576 447.5 511.5 512 432 512C352.5 512 288 447.5 288 368zM491.3 331.3C497.6 325.1 497.6 314.9 491.3 308.7C485.1 302.4 474.9 302.4 468.7 308.7L432 345.4L395.3 308.7C389.1 302.4 378.9 302.4 372.7 308.7C366.4 314.9 366.4 325.1 372.7 331.3L409.4 368L372.7 404.7C366.4 410.9 366.4 421.1 372.7 427.3C378.9 433.6 389.1 433.6 395.3 427.3L432 390.6L468.7 427.3C474.9 433.6 485.1 433.6 491.3 427.3C497.6 421.1 497.6 410.9 491.3 404.7L454.6 368L491.3 331.3z" />
                                                </svg>
                                                <span>REFUSÉ PAR LE DIRECTEUR</span>
                                            </div>
                                            <div v-else v-for="(answer, idx) in request.answers.slice(1, 2)" :key="idx"
                                                class="d-flex justify-content-end">
                                                <div v-if="answer.groupReference == '_receptionist' && answer.status == 'ACCEPTED'"
                                                    class="minibus-demand-positive-opnion d-flex align-items-center justify-content-center">
                                                    <span>APPROUVÉ PAR LA RÉCEPTIONNISTE</span>
                                                </div>
                                                <div v-else-if="answer.groupReference == '_receptionist' && answer.status == 'REFUSED'"
                                                    class="minibus-demand-negative-opnion d-flex align-items-center justify-content-center">
                                                    <span>AVIS DE REFUS</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <h6 style="font-weight: 600">{{ $t("minibus.request.step.three.reason")
                                                    }} :</h6>
                                                <d-input v-if="edit" type="text" id="title" v-model="request.title" />
                                                <span v-else>{{ request.title }}</span>
                                            </div>
                                            <div>
                                                <h6 style="font-weight: 600">{{
                                                    $t("minibus.request.step.three.description") }} : </h6>
                                                <textarea v-if="edit" v-model="request.description"
                                                    class="form-control col-md-12" cols="30" rows="7"
                                                    :placeholder="$t('minibus.request.step.two.reason.discription.placeholder')"></textarea>
                                                <span v-else>{{ request.description }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-purple">
                            <div class="mb-4 mt-3">
                                <div class="card-body">
                                    <div class="py-2 px-3">
                                        <p class="mt-0 d-inline">{{ $t("minibus.managment.demand.decision.description")
                                            }}</p>
                                        <div class="d-inline-flex">
                                            <div class="custom-control custom-radio mb-3 ml-3">
                                                <input type="radio" id="yes" value="yes" name="yes"
                                                    @change="checkAnswer" v-model="decision"
                                                    class="custom-control-input" :disabled=disabled />
                                                <label class="custom-control-label" for="yes">{{
                                                    $t("minibus.managment.demand.decision.accept")
                                                    }}</label>
                                            </div>

                                            <div class="custom-control custom-radio mb-3 ml-3">
                                                <input type="radio" id="no" value="no" name="no" @change="checkAnswer"
                                                    v-model="decision" class="custom-control-input"
                                                    :disabled=disabled />
                                                <label class="custom-control-label" for="no">{{
                                                    $t("minibus.managment.demand.decision.reject")
                                                    }}</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="pl-4">
                                    <div class="" v-show="refusedTextArea">
                                        <div class="card-body">
                                            <textarea class="form-control mt-4" v-model="motif" cols="50" rows="10"
                                                :disabled=disabled></textarea>
                                            <errors field="motifUrgent" :errors="errors"></errors>
                                        </div>
                                    </div>
                                    <div class="" v-show="!refusedTextArea">
                                        <div class="py-2 px-2">
                                            <p class="mt-0 d-inline">{{
                                                $t("minibus.managment.demand.decision.minibus.list.title") }}</p>
                                            <div class="d-flex mt-7 flex-wrap">
                                                <div v-for="(bus, idx) in minibusList" :key="idx"
                                                    class="mb-3 ml-3 d-flex justify-content-center align-items-center">
                                                    <input type="checkbox" :id=bus.reference :name=bus.reference
                                                        v-model="bus.checked" @click="checkboxClicked(bus)"
                                                        class="custom-checkbox-input" :disabled=disabled />
                                                    <label class="ml-2 m-0 custom-checkbox-label" :for=bus.reference>{{
                                                        bus.name
                                                        }}</label>
                                                    <span v-if="bus.available" class="available ml-2">Disponible</span>
                                                    <span v-else class="notAvailable ml-2">Indisponible</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div v-if="thereIsConflict" class="bg-red d-flex justify-content-center">
                            <div class="mb-4 mt-3">
                                <div class="card-body d-flex align-items-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="173" height="173"
                                        viewBox="0 0 173 173" class="mr-7">
                                        <g id="Group_796" data-name="Group 796" transform="translate(-15149 -16723)">
                                            <path id="Path_115" data-name="Path 115" class="cls-1"
                                                d="M336,240H509V413H336Z" transform="translate(14813 16483)" />
                                            <path id="Path_116" data-name="Path 116" class="cls-2"
                                                d="M483.954,257.364H507V411H338V257.364h23.045V242h15.364v15.364h92.182V242h15.364Zm7.682,30.727H353.364V395.636H491.636Z"
                                                transform="translate(14813 16483)" />
                                            <path id="Path_117" data-name="Path 117" class="cls-3"
                                                d="M346,258h19.988v19.988H346Z"
                                                transform="translate(14833.25 16531.25)" />
                                        </g>
                                    </svg>
                                    <div class="ml-7">
                                        <h3 class="minibus-demand-warning-title">Conflit dans le planning pour ces
                                            véhicules</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="!manuelReservation">
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="header-data-table">
                                    <h5 class="header-data-table__heading">
                                        Statut de la demande
                                    </h5>
                                </div>
                                <div class="table-responsive pb-3">
                                    <table class="custom-table table t-responsive">
                                        <thead class="t-header-color">
                                            <tr class="text-center">
                                                <th>Suivi</th>
                                                <th>
                                                    {{ $t("user.firstname") }} {{ $t("user.lastname") }}
                                                </th>
                                                <th>Statut</th>
                                                <th>Date de Création</th>
                                                <th>Date de Modification</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(answer, idx) in listOfUsers.filter((user) => user.groupReference === GroupsEnum.SUPER_ADMIN)"
                                                :key="idx">
                                                <template>
                                                    <td>Direction</td>
                                                </template>
                                                <td>{{ answer.fullName }}</td>
                                                <td v-if="answer.status === 'ACCEPTED'">
                                                    <button class="status-pill-approved">
                                                        <span>{{ $t("global.approved") }}</span>
                                                    </button>
                                                </td>
                                                <td v-else-if="answer.status === 'PENDING'">
                                                    <button class="status-pill-pending">
                                                        <span>{{ $t("global.pending") }}</span>
                                                    </button>
                                                </td>
                                                <td v-else-if="answer.status === 'REFUSED'">
                                                    <button class="status-pill-rejected">
                                                        <span>{{ $t("global.rejected") }}</span>
                                                    </button>
                                                </td>
                                                <td>
                                                    {{
                                                        formatDate(new Date(request.fromDate))
                                                    }}
                                                </td>
                                                <template v-if="
                                                    answer.groupReference === GroupsEnum.SUPER_ADMIN
                                                ">
                                                    <td>{{ `${answer.updateDate ? new
                                                        Date(answer.updateDate).toLocaleDateString("fr-FR") : ""}
                                                        ${answer.updateDate ? new
                                                            Date(answer.updateDate).toLocaleTimeString('fr-FR', {
                                                                hour:
                                                                    '2-digit', minute: '2-digit'
                                                            }) : ""} ` }}</td>
                                                </template>
                                            </tr>
                                            <tr v-for="(answer, idx) in listOfUsers.filter((user) => user.groupReference === GroupsEnum.RECEPTIONIST)"
                                                :key="idx">
                                                <template>
                                                    <td>Réceptionniste</td>
                                                </template>
                                                <td>{{ answer.fullName }}</td>
                                                <td v-if="answer.status === 'ACCEPTED'">
                                                    <button class="status-pill-approved">
                                                        <span>{{ $t("global.approved") }}</span>
                                                    </button>
                                                </td>
                                                <td v-else-if="answer.status === 'PENDING'">
                                                    <button class="status-pill-pending">
                                                        <span>{{ $t("global.pending") }}</span>
                                                    </button>
                                                </td>
                                                <td v-else-if="answer.status === 'REFUSED'">
                                                    <button class="status-pill-rejected">
                                                        <span>{{ $t("global.rejected") }}</span>
                                                    </button>
                                                </td>
                                                <td>
                                                    {{
                                                        formatDate(new Date(request.fromDate))
                                                    }}
                                                </td>
                                                <template v-if="answer.groupReference === GroupsEnum.RECEPTIONIST">
                                                    <td>{{ `${answer.updateDate ? new
                                                        Date(answer.updateDate).toLocaleDateString("fr-FR") : ""}
                                                        ${answer.updateDate ? new
                                                            Date(answer.updateDate).toLocaleTimeString('fr-FR', {
                                                                hour:
                                                                    '2-digit', minute: '2-digit'
                                                            }) : ""} ` }}</td>
                                                </template>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>

        </div>
    </div>
</template>

<script>
import SpinnerDot from "../../components/layout/Loading/spinner-dot";
import TimeUtils from '../../utils/TimeUtils';
import GroupsEnum from "../../data/groups/GroupsEnum";
import { fr } from 'vuejs-datepicker/dist/locale';
import Long from "long";

export default {
    name: "Minibus-demand",
    components: {
        SpinnerDot
    },
    methods: {
        checkboxClicked(bus) {
            bus.checked = !bus.checked;
            if (bus.checked == true && bus.available == false) {
                this.thereIsConflict = true;
            } else {
                this.thereIsConflict = false;
            }
        },
        formatDate(date) {
            return new Date(date).toLocaleDateString("fr-FR");
        },
        formatTime(date) {
            return TimeUtils.formatTime(date);
        },
        getFullDate(date, Hour, Minute) {
            date = new Date(date);
            let hours = parseInt(Hour) * 60 * 60 * 1000;
            let min = parseInt(Minute) * 60 * 1000;
            let calculatedDate = new Date(date.toISOString().split('T')[0]).subtractHours(1).getTime() + hours + min;
            return new Date(calculatedDate);
        },
        checkAnswer() {
            if (this.decision === 'no') {
                this.refusedTextArea = true;
            } else {
                this.refusedTextArea = false;
            }
        },
        validate() {
            this.loading = true;
            this.minibusChecked = this.minibusList.filter(minibus => minibus.checked == true);
            let cleanedMinibusList = [];
            this.minibusList.forEach((minibus) => {
                if (minibus.checked == true) {
                    cleanedMinibusList.push({ reference: minibus.reference });
                }
            });

            const baseRequest = {
                reference: this.request.reference,
                title: this.request.title,
                description: this.request.description,
                destination: this.request.destination,
                fromDate: this.request.fromDate,
                toDate: this.request.toDate,
                firstName: this.request.firstName,
                lastName: this.request.lastName,
                email: this.request.email,
                userReference: this.request.userReference,
                userFirstName: this.request.userFirstName,
                userLastName: this.request.userLastName,
                userUpdateDate: this.request.userUpdateDate ?
                    [{ reference: this.$store.state.user.informations.reference, date: new Date(), status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED" }, ...this.request.userUpdateDate] :
                    [{ reference: this.$store.state.user.informations.reference, date: new Date(), status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED" }]
            };

            if (this.canMakeFinalDecision) {
                // Final decision logic (Super Admin or Minibus Admin)
                let requestSent = {
                    ...baseRequest,
                    status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED",
                    answers: [
                        {
                            groupReference: "_super_admin",
                            position: null,
                            userReference: this.$store.state.user.informations.reference,
                            status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED"
                        },
                        this.request.answers[1] // Keep receptionist answer
                    ],
                    minibusList: cleanedMinibusList,
                    directorUpdateDate: new Date()
                };
                if (this.decision === 'no') {
                    requestSent.rejectReason = this.motif;
                }

                this.$services.minibusRequest.update(this.request.reference, requestSent)
                    .then(() => {
                        if (this.decision === 'yes') {
                            this.minibusChecked.forEach((minbus) => {
                                let model = {
                                    fromDate: this.getFullDate(this.request.fromDate, this.model.startHour, this.model.startMinute),
                                    toDate: this.getFullDate(this.request.toDate, this.model.endHour, this.model.endMinute),
                                    requestReference: this.request.reference,
                                    minibusReference: minbus.reference
                                };
                                this.$services.minibusManagement.createReservation(model);
                            });
                        }
                        this.$miniToastr.success("Minibus modifiée avec succès");
                        this.$router.go();
                        this.loading = false;
                    })
                    .catch((e) => {
                        this.$miniToastr.error("Une erreur s'est produite lors de la modification de votre demande");
                        this.loading = false;
                    });
            } else if (this.isReceptionist) {
                // Opinion logic (Receptionist without Minibus Admin)
                let requestSent = {
                    ...baseRequest,
                    answers: [
                        this.request.answers[0], // Keep super admin answer
                        {
                            groupReference: "_receptionist",
                            position: null,
                            userReference: this.$store.state.user.informations.reference,
                            status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED"
                        }
                    ],
                    minibusList: cleanedMinibusList
                };
                if (this.decision === 'no') {
                    requestSent.rejectReason = this.motif;
                }

                this.$services.minibusRequest.update(this.request.reference, requestSent)
                    .then(() => {
                        this.$miniToastr.success("Minibus modifiée avec succès");
                        this.$router.go();
                        this.loading = false;
                    })
                    .catch((e) => {
                        this.$miniToastr.error("Une erreur s'est produite lors de la modification de votre demande");
                        this.loading = false;
                    });
            } else {
                this.$miniToastr.error("Vous n'êtes pas autorisé à effectuer cette action");
                this.loading = false;
                return;
            }
        },
        backToList() {
            this.$router.push(`/demandes/minibus/management`);
        },
        goToPlaning() {
            this.$router.push(`/minibus/planing/${this.request.reference}`);
        },
        async cancelEditing() {
            this.edit = false;
            this.request = JSON.parse(JSON.stringify(this.originalRequest));
            this.model.startHour = this.hours[parseInt(new Date(this.originalRequest.fromDate).getHours())]
            this.model.startMinute = new Date(this.originalRequest.fromDate).getMinutes() ? new Date(this.originalRequest.fromDate).getMinutes() : "00";
            this.model.endHour = this.hours[parseInt(new Date(this.originalRequest.toDate).getHours())]
            this.model.endMinute = new Date(this.originalRequest.toDate).getMinutes() ? new Date(this.originalRequest.toDate).getMinutes() : "00";
            if (this.originalRequest.answers[0].status == "ACCEPTED" || this.originalRequest.answers[1].status == "ACCEPTED") {
                this.decision = 'yes';
                this.checkAnswer();
            }
            if (this.originalRequest.answers[0].status == "REFUSED" || this.originalRequest.answers[1].status == "REFUSED") {
                this.decision = 'no';
                this.checkAnswer();
            }
            if (this.originalRequest.answers[0].status == "ACCEPTED" || this.originalRequest.answers[0].status == "REFUSED") {
                this.disabled = true;
            }
            if (this.originalRequest.answers[1].status == "ACCEPTED" || this.originalRequest.answers[1].status == "REFUSED") {
                this.disabled = true;
            }

            this.checkDates();

        },
        async deleteDemand() {
            this.minibusChecked = this.minibusList.filter(minibus => minibus.checked == true);
            await this.$services.minibusRequest.deleteRequest(this.request.reference)
                .then((res) => {
                    this.minibusChecked.forEach(minibus => {
                        this.$services.minibusManagement.deleteReservationByMinibusRefAndRequestRef({ minibusRef: minibus.reference, requestRef: this.request.reference })
                            .catch((e) => { this.$miniToastr.error("Il y a eu une erreur lors de l'supprimée du demande"); })
                    })
                })
                .catch((e) => { this.$miniToastr.error("Il y a eu une erreur lors de l'supprimée du demande"); })
            this.$router.push(`/demandes/minibus/management`);
            this.$miniToastr.success("Demande supprimée avec succès");

        },
        editDemand() {
            this.minibusChecked = this.minibusList.filter(minibus => minibus.checked == true);
            let cleanedMinibusList = [];
            this.minibusList.forEach((minibus) => {
                if (minibus.checked == true) {
                    cleanedMinibusList.push({ reference: minibus.reference });
                }
            });
            this.disabled = false;

            if (this.edit == true) {
                let request = {
                    firstName: this.request.firstName,
                    lastName: this.request.lastName,
                    email: this.request.email,
                    title: this.request.title,
                    reference: this.request.reference,
                    description: this.request.description,
                    destination: this.request.destination,
                    userReference: this.request.userReference,
                    answers: this.request.answers,
                    fromDate: this.getFullDate(this.request.fromDate, this.model.startHour, this.model.startMinute),
                    toDate: this.getFullDate(this.request.toDate, this.model.endHour, this.model.endMinute),
                    userUpdateDate: this.request.userUpdateDate ?
                        [...this.request.userUpdateDate, { reference: this.$store.state.user.informations.reference, date: new Date(), status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED" }] :
                        [{ reference: this.$store.state.user.informations.reference, date: new Date(), status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED" }]
                };

                if (this.canMakeFinalDecision) {
                    // Final decision logic
                    request.status = this.decision === 'yes' ? "ACCEPTED" : "REFUSED";
                    request.answers = [
                        {
                            groupReference: "_super_admin",
                            position: null,
                            userReference: this.$store.state.user.informations.reference,
                            status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED"
                        },
                        this.request.answers[1]
                    ];
                    request.minibusList = cleanedMinibusList;
                    request.directorUpdateDate = new Date();
                    if (this.decision === 'no') {
                        request.rejectReason = this.motif;
                        request.minibusList = [];
                    }

                    // Update minibus reservations
                    let checkedMinibusList = this.minibusList;
                    checkedMinibusList.forEach((checkedMinibus) => {
                        if (checkedMinibus.checked == false || this.decision === 'no') {
                            this.$services.minibusManagement.deleteReservationByMinibusRefAndRequestRef({ minibusRef: checkedMinibus.reference, requestRef: this.request.reference })
                                .catch((e) => { this.$miniToastr.error("Il y a eu une erreur lors de l'éditer du minibus"); });
                        } else if (this.decision === 'yes') {
                            this.$services.minibusManagement.updateReservationByMinibusRefAndRequestRef({
                                minibusRef: checkedMinibus.reference,
                                requestRef: this.request.reference,
                                fromDate: this.getFullDate(this.request.fromDate, this.model.startHour, this.model.startMinute),
                                toDate: this.getFullDate(this.request.toDate, this.model.endHour, this.model.endMinute)
                            })
                                .catch((e) => { this.$miniToastr.error(e); console.warn(e); });
                        }
                    });
                } else if (this.isReceptionist) {
                    // Opinion logic
                    if (this.request.answers[0].status == "ACCEPTED" || this.request.answers[0].status == "REFUSED") {
                        request.status = this.request.answers[0].status;
                        request.answers = [
                            {
                                groupReference: "_super_admin",
                                position: null,
                                userReference: this.request.answers[0].userReference,
                                status: this.request.answers[0].status
                            },
                            {
                                groupReference: "_receptionist",
                                position: null,
                                userReference: this.$store.state.user.informations.reference,
                                status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED"
                            }
                        ];
                        request.minibusList = this.request.answers[0].status === "ACCEPTED" ? cleanedMinibusList : [];
                        if (this.decision === 'no') {
                            request.rejectReason = this.motif;
                        }
                        if (this.request.answers[0].status === "REFUSED") {
                            this.minibusList.forEach((minibus) => {
                                this.$services.minibusManagement.deleteReservationByMinibusRefAndRequestRef({ minibusRef: minibus.reference, requestRef: this.request.reference })
                                    .catch((e) => { this.$miniToastr.error("Il y a eu une erreur lors de l'éditer du minibus"); });
                            });
                        }
                    } else {
                        request.answers = [
                            this.request.answers[0],
                            {
                                groupReference: "_receptionist",
                                position: null,
                                userReference: this.$store.state.user.informations.reference,
                                status: this.decision === 'yes' ? "ACCEPTED" : "REFUSED"
                            }
                        ];
                        request.minibusList = cleanedMinibusList;
                        if (this.decision === 'no') {
                            request.rejectReason = this.motif;
                        }
                    }
                } else {
                    this.$miniToastr.error("Vous n'êtes pas autorisé à effectuer cette action");
                    this.loading = false;
                    return;
                }

                this.$services.minibusRequest.update(this.request.reference, request)
                    .then(() => {
                        this.$miniToastr.success("Minibus modifiée avec succès");
                        this.$router.go();
                        this.loading = false;
                    })
                    .catch((e) => {
                        this.$miniToastr.error("Une erreur s'est produite lors de la modification de votre demande");
                        this.loading = false;
                    });
            }
            this.edit = !this.edit;
        },
        checkDates() {
            if (this.request.toDate < this.request.fromDate) {
                this.request.toDate = this.request.fromDate;
            }
            this.$services.minibusManagement.reservationsCheckConflict({ fromDate: this.getFullDate(this.request.fromDate, this.model.startHour, this.model.startMinute), toDate: this.getFullDate(this.request.toDate, this.model.endHour, this.model.endMinute) })
                .then((res) => {
                    for (let minibus in this.minibusList) {
                        this.minibusList[minibus].available = true;
                        for (let bus in res.data) {
                            if (this.minibusList[minibus].checked == false && this.minibusList[minibus].reference == res.data[bus].minibusReference) {
                                this.minibusList[minibus].available = false;
                            }
                        }
                    }
                })

        },
    },
    data() {
        return {
            reference: null,
            loading: true,
            GroupsEnum,
            originalRequest: null,
            request: null,
            decision: 'yes',
            refusedTextArea: false,
            motif: null,
            disabled: false,
            errors: [],
            listOfUsers: [],
            minibusList: [],
            minibusChecked: [],
            checkedList: [],
            manuelReservation: false,
            beneficiary: {
                firstName: "",
                lastName: "",
                isExternalPerson: false,
                structName: ""
            },
            edit: false,
            thereIsConflict: false,
            fr,
            model: {
                startHour: 11,
                startMinute: 20,
                endHour: 9,
                endMinute: 30
            },
            hours: [
                '00', '01', '02', '03', '04', '05', '06', '07', '08', '09',
                '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
                '20', '21', '22', '23'
            ],
            minutes: ['00', '10', '20', '30', '40', '50']
        };
    },
    computed: {
        canMakeFinalDecision() {
            const userGroups = this.$store.state.user.informations.permissions.map(p => p.groupReference);
            return userGroups.includes("_super_admin") || userGroups.includes("_minibus_admin");
        },
        isReceptionist() {
            const userGroups = this.$store.state.user.informations.permissions.map(p => p.groupReference);
            return userGroups.includes("_receptionist") && !this.canMakeFinalDecision;
        }
    },
    mounted() {
        this.reference = this.$route.params.reference;
        this.$services.minibusRequest.findByReference(this.reference)
            .then(({ data }) => {
                if (data.manuelReservation) {
                    this.manuelReservation = data.manuelReservation;
                }

                if (data.isExternalClient) {
                    this.beneficiary = {
                        firstName: data.firstName,
                        lastName: data.lastName,
                        isExternalPerson: true
                    }
                } else {
                    this.$services.user.getUserData(data.userReference).then((userData) => {
                        this.beneficiary = {
                            firstName: userData.data.firstName,
                            lastName: userData.data.lastName,
                            isExternalPerson: false
                        }

                        this.$services.structure.findByReference(userData.data.structureReference).then((structData) => {
                            this.beneficiary = {
                                firstName: userData.data.firstName,
                                lastName: userData.data.lastName,
                                isExternalPerson: false,
                                structName: structData.data.name,
                            }
                        })

                    })

                }
                if ((this.$store.state.user.informations.permissions[0].groupReference == "_super_admin" && (data.answers[0].status == "REFUSED" || data.answers[0].status == "ACCEPTED")) || (this.$store.state.user.informations.permissions[0].groupReference == "_receptionist" && (data.answers[1].status == "REFUSED" || data.answers[1].status == "ACCEPTED"))) {
                    this.disabled = true;
                }
                if (data.answers[0].status == "REFUSED") {
                    this.decision = 'no';
                    this.motif = data.rejectReason;
                    this.checkAnswer();
                }
                else if (data.answers[0].status == "ACCEPTED" || data.answers[1].status == "ACCEPTED") {
                    this.decision = 'yes';
                    if (data.minibusList) {
                        this.checkedList = data.minibusList

                    }
                } else {
                    if (data.answers[1].status == "ACCEPTED") {
                        this.decision = 'yes';
                    } else if (data.answers[1].status == "REFUSED") {
                        this.decision = 'no';
                        this.motif = data.rejectReason;
                        this.checkAnswer();

                    }
                }
                this.request = data;
                this.originalRequest = JSON.parse(JSON.stringify(data));
                this.loading = false;
                this.model.startHour = this.hours[parseInt(data.fromDate.split('T')[1].split(':')[0]) + 1]
                this.model.startMinute = new Date(data.fromDate).getMinutes() ? new Date(data.fromDate).getMinutes() : "00";
                this.model.endHour = this.hours[parseInt(data.toDate.split('T')[1].split(':')[0]) + 1]
                this.model.endMinute = new Date(data.toDate).getMinutes() ? new Date(data.toDate).getMinutes() : "00";
                this.$services.minibusManagement.findAll()
                    .then(({ data }) => {
                        this.minibusList = data.data.filter(minibus => minibus.available == true);
                        for (let bus in this.minibusList) {
                            this.minibusList[bus].checked = false;
                        }
                        this.minibusList.forEach((minibus) => {
                            this.checkedList.forEach((checkedMinibus) => {
                                if (minibus.reference == checkedMinibus.reference) {
                                    minibus.checked = true;
                                }
                            })
                            this.$services.minibusManagement.reservationsCheckConflictExcludeRef({ fromDate: this.request.fromDate, toDate: this.request.toDate, requestRef: this.reference, minibusRef: minibus.reference })
                                .then((res) => {
                                    for (let minibus in this.minibusList) {
                                        for (let bus in res.data) {
                                            if (this.minibusList[minibus].reference == res.data[bus].minibusReference) {
                                                this.minibusList[minibus].available = false;
                                            }
                                        }
                                    }
                                })
                        })

                        this.loading = false;

                    })

            });

        this.$services.user.getUsers()
            .then((data) => {
                data.data.forEach((user) => {
                    if (user.permissions[0] && user.permissions[0].groupReference == '_super_admin') {
                        this.listOfUsers.push({ groupReference: "_super_admin", status: "PENDING", userReference: user.reference, fullName: user.firstName + " " + user.lastName });
                    }
                    if (user.permissions[0] && user.permissions[0].groupReference == '_receptionist') {
                        this.listOfUsers.push({ groupReference: "_receptionist", status: "PENDING", userReference: user.reference, fullName: user.firstName + " " + user.lastName, updateDate: null });
                    }
                })
                this.listOfUsers.forEach((user) => {
                    this.request.userUpdateDate.forEach((recep) => {
                        if (user.userReference == recep.reference) {
                            user.updateDate = recep.date
                            user.status = recep.status
                        }
                    })

                });
            }
            ).catch((e) => console.log("error: ", e))


    },

}
</script>

<style>
.bg-purple {
    background-color: #F6F8FF;
}

.bg-red {
    background-color: rgba(196, 24, 60, 0.15);
    border-radius: 0 0 0.625rem 0.625rem;
}

.available {
    display: block;
    border: 1px solid #17c671;
    width: 120px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(23, 198, 113, 0.24);
    color: #17c671;
    margin: auto 0;
    text-align: center;
}

.notAvailable {
    display: block;
    border: 1px solid #c4183c;
    width: 120px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(196, 24, 60, 0.24);
    color: #c4183c;
    margin: auto 0;
    text-align: center;
}

.custom-checkbox-label {
    font-size: 16px !important;
}

.custom-checkbox-input {
    width: 20px !important;
    height: 20px !important;
    accent-color: #4F78E1 !important;
}

.cls-1 {
    fill: rgba(0, 0, 0, 0);
}

.cls-2,
.cls-3 {
    fill: #c4183c;
}

.cls-3 {
    fill-rule: evenodd;
}

.minibus-demand-warning-title {
    color: #c4183c;
}

.minibus-demand-warning-subtitle {
    color: #c4183c;
    font-size: 20px;
    font-weight: 300;
}

.minibus-demand-positive-opnion {
    background-color: #17c671;
    color: white;
    width: 200px;
    font-size: 15px;
    padding: 10px;
    text-align: center;
}

.minibus-demand-negative-opnion {
    background-color: #c4183c;
    color: white;
    width: 200px;
    font-size: 15px;
    padding: 10px;
    text-align: center;
    vertical-align: middle;
}

.return-btn {
    background-color: #ffffff !important;
    color: #7070ba !important;
}

.return-btn i {
    margin-right: 5px;
}
</style>
